// extracted by mini-css-extract-plugin
export default {"mainContainer":"CustomerOrders_mainContainer__Acr1H","heading":"CustomerOrders_heading__TcpLy","card":"CustomerOrders_card__JRq4z"};